import { CURRENT_PRICING } from '@/api/consts'
import type { OfferId, SubscriptionCreateParams, SubscriptionCreateResponse } from '@/api/schema'
import { Row } from '@/app/components/Flex/Flex'
import { Motion } from '@/app/components/Motion/Motion'
import { OfferLogin } from '@/app/components/OfferV2/OfferLogin/OfferLogin'
import { Offers } from '@/app/components/OfferV2/Offers/Offers'
import { Lib } from '@/app/components/UI/Lib'
import { UI } from '@/app/components/UI/UI'
import { useSession } from '@/app/state/session'
import { api } from '@/app/utils/api'
import { parseError } from '@/app/utils/error'
import { metrikaGoal } from '@/app/utils/metrika'
import type { FunctionalComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'

export const ChatOfferV2: FunctionalComponent = () => {
  const [offerActiveId, setOfferActiveId] = useState<OfferId>('one')
  const [loginVisible, setLoginVisible] = useState(false)
  const [errors, setErrors] = useState<string[]>([])
  const [loading, setLoading] = useState(false)

  const userEmail = useSession(s => s.user?.email)
  const pricing = useSession(useShallow(s => s.user?.pricing ?? CURRENT_PRICING))

  const pay = async () => {
    try {
      setErrors([])
      setLoading(true)

      const resp = await api.post<SubscriptionCreateResponse>(
        '/subscription/create',
        {
          offerId: offerActiveId,
        } satisfies SubscriptionCreateParams,
      )

      metrikaGoal('chat_pay_redirect', {}, () => {
        window.location.href = resp.data.confirmationUrl
      })
    }
    catch (e) {
      console.error(e)
      setLoginVisible(false)
      setErrors(parseError(e))
      setLoading(false)
    }
  }

  useEffect(() => {
    metrikaGoal('paywall')
  }, [])

  return (
    <UI.Panel
      shadow
      radius='l'
    >
      {loginVisible
        ? (
          <Motion key='login'>
            <OfferLogin
              onSuccess={() => {
                pay()
              }}
              onBack={() => {
                setLoginVisible(false)
              }}
            />
          </Motion>
        )
        : (
          <Motion key='offer'>
            <Row gap={15}>
              <Offers
                activeId={offerActiveId}
                onChange={setOfferActiveId}
              />

              <Lib.Errors errors={errors} />

              <Row gap={15} alignItems='center'>
                <UI.Button
                  block
                  size='l'
                  type='primary'
                  disabled={loading}
                  htmlType='button'
                  onClick={async () => {
                    metrikaGoal('chat_click_access')

                    if (!userEmail) {
                      setLoginVisible(true)
                    }
                    else {
                      pay()
                    }
                  }}
                >
                  Продолжить за {pricing.amount[offerActiveId]} ₽
                </UI.Button>

                <UI.Hint>
                  Разовый платёж, без автосписаний
                </UI.Hint>
              </Row>
            </Row>
          </Motion>
        )}
    </UI.Panel>
  )
}
